import { getPictogrammeById } from '@/constants/pictogrammesChantier';
import { cn } from '@/lib/utils';
import { HelpCircle } from 'lucide-react';

interface ChantierIconProps {
  pictogramme: string;
  couleur: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showBackground?: boolean;
}

const sizeClasses = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};

const containerSizeClasses = {
  sm: 'w-6 h-6 rounded',
  md: 'w-8 h-8 rounded-lg',
  lg: 'w-10 h-10 rounded-xl',
};

export function ChantierIcon({
  pictogramme,
  couleur,
  size = 'md',
  className,
  showBackground = true,
}: ChantierIconProps) {
  const picto = getPictogrammeById(pictogramme);

  // Fallback si pictogramme non trouvé
  if (!picto) {
    if (showBackground) {
      return (
        <div
          className={cn(
            containerSizeClasses[size],
            'bg-muted flex items-center justify-center',
            className
          )}
        >
          <HelpCircle className={cn(sizeClasses[size], 'text-muted-foreground')} />
        </div>
      );
    }
    return <HelpCircle className={cn(sizeClasses[size], 'text-muted-foreground', className)} />;
  }

  const Icon = picto.icon;

  if (showBackground) {
    return (
      <div
        className={cn(
          containerSizeClasses[size],
          'flex items-center justify-center flex-shrink-0',
          className
        )}
        style={{ backgroundColor: `${couleur}20` }}
      >
        <Icon className={sizeClasses[size]} style={{ color: couleur }} />
      </div>
    );
  }

  return (
    <Icon
      className={cn(sizeClasses[size], 'flex-shrink-0', className)}
      style={{ color: couleur }}
    />
  );
}
